// TODO refactor

export const useFamilyShadowMember = () => {
  const profile = useProfileStore();
  const context = useContextStore();
  const avatarUrl = computed(() => {
    return profile.mediaAvatar.urlCompressed;
  });

  const name = computed(() => {
    return profile.displayName;
  });
  const id = computed(() => {
    return context.memberId;
  });
  return {
    // avatar?: string;
    // avatarUrl?: string;
    // firstname?: string;
    // lastname?: string;
    // hasNomadPlusFamilyActive?: boolean;
    // loginToken?: string;
    // mainContentLibraryBookId?: string;
    // memberId?: string;
    // displayInviteButton?: boolean;
    // isPlaceholder?: boolean;
    // name?: string;
    // status?: 'parent' | 'child';
    // totalInMinutes?: number;
    // levelOfEducationName?: string;
    // email?: string;
    // profilingInfos?: ProfilingInfo[];
    // coaching: CoachingInfos;
    // gamingXp?: number;
    // levelOfEducationLongName?: string;
    // displayEmail?: boolean;
    // shareResultsWithFamily?: boolean;
    // familyInviteUrl?: string;
    avatarUrl,
    name,
    id,
  };
};
